import 'angularTable';
import TableFilter from 'edge/platform/widgets/table/TableFilter';

export default angular.module('edge.platform.widgets.table', ['angular-table'])
    .component('gwTableFilter', TableFilter);